"use strict";

exports.__esModule = true;
exports.timeGrouping = exports.getTimeGroupingNameFromAgg = exports.getTimeGroupingLabel = exports.getTimeGroupingFromAgg = exports.getTimeGroupingBinName = exports.getTimeAggregationBin = exports.HOUR_PER_DAY = exports.HOUR_OF_DAY = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HOUR_PER_DAY = exports.HOUR_PER_DAY = "day-hour";
var HOUR_OF_DAY = exports.HOUR_OF_DAY = "hour";
var timeGrouping = exports.timeGrouping = [{
  name: HOUR_PER_DAY,
  binName: "by_day_hour",
  label: "Hour",
  type: "hour-day"
}, {
  name: HOUR_OF_DAY,
  binName: "by_hour",
  label: "Hour of Day",
  type: "hour"
}, {
  name: "day",
  binName: "by_workday",
  label: "Day",
  type: "day"
}, {
  name: "week",
  binName: "by_week",
  label: "Week",
  type: "week"
}, {
  name: "month",
  binName: "by_month",
  label: "Month",
  type: "month"
}, {
  name: "quarter",
  binName: "by_quarter",
  label: "Quarter",
  type: "quarter"
}, {
  name: "year",
  binName: "by_year",
  label: "Year",
  type: "year"
}];
var getTimeAggregationBin = exports.getTimeAggregationBin = function getTimeAggregationBin(aggregationName, options) {
  var timezoneName = options.timezoneName;
  switch (aggregationName) {
    case HOUR_PER_DAY:
      return {
        binName: "by_day_hour",
        fieldName: "timestamp",
        aggType: "date_histogram",
        options: {
          calendar_interval: "hour"
        }
      };
    case HOUR_OF_DAY:
      return {
        binName: "by_hour",
        fieldName: "timestamp",
        aggType: "script",
        options: {
          scriptName: "hour_of_day",
          scriptParams: {
            fieldName: "timestamp",
            timezoneOffset: (0, _momentTimezone["default"])().tz(timezoneName).format("Z")
          }
        }
      };
    case "day":
      return {
        binName: "by_workday",
        fieldName: "dimensions.workday",
        aggType: "date_histogram",
        options: {
          calendar_interval: "day",
          script: {
            scriptName: "exclude_days_of_week",
            ignoreScript: true
          }
        }
      };
    case "week":
      return {
        binName: "by_week",
        fieldName: "dimensions.workday",
        aggType: "date_histogram",
        options: {
          calendar_interval: "week",
          script: {
            scriptName: "exclude_days_of_week",
            ignoreScript: true
          }
        }
      };
    case "month":
      return {
        binName: "by_month",
        fieldName: "dimensions.workday",
        aggType: "date_histogram",
        options: {
          calendar_interval: "month",
          script: {
            scriptName: "exclude_days_of_week",
            ignoreScript: true
          }
        }
      };
    case "quarter":
      return {
        binName: "by_quarter",
        fieldName: "dimensions.workday",
        aggType: "date_histogram",
        options: {
          calendar_interval: "quarter",
          script: {
            scriptName: "exclude_days_of_week",
            ignoreScript: true
          }
        }
      };
    case "year":
      return {
        binName: "by_year",
        fieldName: "dimensions.workday",
        aggType: "date_histogram",
        options: {
          calendar_interval: "year",
          script: {
            scriptName: "exclude_days_of_week",
            ignoreScript: true
          }
        }
      };
  }
};
var getTimeGroupingLabel = exports.getTimeGroupingLabel = function getTimeGroupingLabel(name) {
  var timeAggregation = timeGrouping.find(function (window) {
    return window.name === name;
  });
  if (timeAggregation) {
    return timeAggregation.label;
  }
  return name;
};
var getTimeGroupingBinName = exports.getTimeGroupingBinName = function getTimeGroupingBinName(name) {
  var timeAggregation = timeGrouping.find(function (window) {
    return window.name === name;
  });
  if (timeAggregation) {
    return timeAggregation.binName;
  }
  return name;
};
var getTimeGroupingNameFromAgg = exports.getTimeGroupingNameFromAgg = function getTimeGroupingNameFromAgg(_ref) {
  var aggregations = _ref.aggregations;
  var timeAggregation = aggregations.find(function (d) {
    return d.id === "workday";
  });
  return timeAggregation && timeAggregation.name || "";
};
var getTimeGroupingFromAgg = exports.getTimeGroupingFromAgg = function getTimeGroupingFromAgg(_ref2) {
  var aggregations = _ref2.aggregations;
  return aggregations.find(function (d) {
    return d.id === "workday";
  });
};